import React from 'react';
import he from 'he';
import { StyledRecipients, StyledRecipientsBox, StyledTable } from './styles';

export type Staff = {
  staff_id: number;
  name: string;
  phone: string;
  email: string | null;
};

interface Props {
  staff: Staff[];
}

const ScheduleRecipient = ({ staff }: Props) => {
  return (
    <StyledRecipientsBox>
      <StyledRecipients>
        <StyledTable>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>E-mail</th>
                <th>Tel</th>
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 ? (
                <tr>
                  <td className="no-data" colSpan={3}>
                    No Data
                  </td>
                </tr>
              ) : (
                staff.map(({ email, name, phone, staff_id }) => {
                  return (
                    <tr key={staff_id}>
                      <td>{he.decode(name || '')}</td>
                      <td>{he.decode(email || '')}</td>
                      <td>{phone}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </StyledTable>
      </StyledRecipients>
    </StyledRecipientsBox>
  );
};

export default ScheduleRecipient;
